import Vue from "vue";
import userApi from "@/common/api/user.api";
import { eventHub } from "@/main";

let instance;

export const getInstance = () => instance;

export const useSession = () => {
  if (instance) return instance;

  instance = new Vue({
    data: {
      currentUser: {},
      isAdmin: false
    },

    created() {
      this.currentUser = userApi.getCurrentUser() || {};
      this.isAdmin = this.currentUser.isAdmin;
      this.permissionLevel = this.currentUser.permissionLevel;
      this.clientRoles = this.currentUser.clientRoles;

      eventHub.$on("LOGGED_USER", (user) => {
        this.currentUser = user;
        this.isAdmin = user.isAdmin;
        this.permissionLevel = user.permissionLevel;
        this.clientRoles = user.clientRoles;
      });
    }
  });

  return instance;
};

const Session = {
  install(Vue, options) {
    Vue.prototype.$session = useSession(options);
  }
};

export default Session;

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Session)
}